// Google Tag Manager dataLayer-events.

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

// Google enhanced conversions verwacht telefoonnummers in E.164-formaat
// (bijv. +31612345678); nationale notatie (06..., 085...) wordt omgezet.
function normalizePhone(phone: string): string | undefined {
  const cleaned = phone.replace(/[^\d+]/g, '');
  if (!cleaned) return undefined;
  if (cleaned.startsWith('+')) return cleaned;
  if (cleaned.startsWith('00')) return `+${cleaned.slice(2)}`;
  if (cleaned.startsWith('0')) return `+31${cleaned.slice(1)}`;
  return cleaned;
}

export function trackGenerateLead({
  formName,
  email,
  phone,
}: {
  formName: string;
  email?: string;
  phone?: string;
}) {
  const enhancedConversionData: { email?: string; phone_number?: string } = {};

  const normalizedEmail = email?.trim().toLowerCase();
  if (normalizedEmail) enhancedConversionData.email = normalizedEmail;

  const normalizedPhone = phone ? normalizePhone(phone) : undefined;
  if (normalizedPhone) enhancedConversionData.phone_number = normalizedPhone;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'generate_lead',
    form_name: formName,
    ...(Object.keys(enhancedConversionData).length > 0
      ? { enhanced_conversion_data: enhancedConversionData }
      : {}),
  });
}

// Klik op een tel:-, mailto:- of WhatsApp-link. Zo maken we contact
// meetbaar in GTM, naast de formulier- en Calendly-conversies.
export function trackContactClick({
  method,
  location,
}: {
  method: 'phone' | 'email' | 'whatsapp';
  location: string;
}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'contact_click',
    contact_method: method,
    contact_location: location,
  });
}

// Calendly meldt via postMessage wanneer een bezoeker in de embedded widget
// daadwerkelijk een afspraak boekt; dit event maakt dat meetbaar in GTM.
export function trackCalendlyScheduled() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'calendly_event_scheduled',
    form_name: 'calendly',
  });
}
